<template>
	<div class="page-body">
		<page-header></page-header>
		<div class="page-wrap">
			<page-slider :menus='menus'></page-slider>
			<el-scrollbar class="page-main">
				<router-view></router-view>
			</el-scrollbar>
		</div>
		<page-apply :apply-data="applyData" v-loading="loading" v-if="applyData.status!==2"></page-apply>
		<page-footer></page-footer>
	</div>
</template>

<script>
	import pageHeader from './components/header.vue'
	import pageFooter from './components/footer.vue'
	
	export default {
		components: {
			pageHeader,
			pageFooter,
		},
		data() {
			return {
				
			}
		},
		created() {
			this.checkApply();
		},
		methods: {
			checkApply(){
				this.loading = true;
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.page-body {
		height: 100%;
		min-width: 1280px;
		.page-wrap {
			display: flex;
			height: calc(100% - 132px);
			.page-main {
				flex: 1;
				width: 0;
				height: 100%;
				display: block;
			}
		}
	}
</style>
